import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-healthchecks',
  templateUrl: './help-healthchecks.component.html',
  styleUrls: ['./help-healthchecks.component.scss']
})
export class HelpHealthchecksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
